import React, { useEffect, useState } from "react";
import Dialog from "@material-ui/core/Dialog";
import t from "../../../helpers/t";
import { useSelector, paketinActions } from "inbooma-api";
import { Biscuit } from "../../../../utils";
import { moment } from "../../../../../vendor";
import Loader from "../../../components/Loader";

const ShowStatusDialog = ({ handleCloseDialog, dispatch, facilitySlot }) => {
  const _checkBox = useSelector((state) => state.paketins_data.checkBox);
  const _deletePin = useSelector((state) => state.paketins_data.deletePin);
  const [initialized, setInitialized] = useState(false);
  const [boxPending, setBoxPending] = useState(false);
  const [deletePinPending, setDeletePinPending] = useState(false);

  useEffect(() => {
    if (facilitySlot !== null) {
      dispatch(
        paketinActions.checkBox({
          token: Biscuit.get("token"),
          data: {
            boxid: facilitySlot.external_resource_id,
          },
        }),
      );
      setBoxPending(true);
      setInitialized(true);
    }
  }, []);

  useEffect(() => {
    if (_checkBox.success === "" || boxPending === false) {
      return;
    }
    setBoxPending(false);
  }, [_checkBox]);

  useEffect(() => {
    if (_deletePin.success === "" || deletePinPending === false) {
      return;
    }
    if (_deletePin.success === true) {
      dispatch(
        paketinActions.checkBox({
          token: Biscuit.get("token"),
          data: {
            boxid: facilitySlot.external_resource_id,
          },
        }),
      );
      setBoxPending(true);
    }
    setDeletePinPending(false);
  }, [_deletePin]);

  const deletePin = (box) => {
    if (confirm(t("really_remove"))) {
      let pin = null;
      if (typeof box.merchantPin !== "undefined") {
        pin = box.merchantPin;
      }
      if (pin === null && typeof box.customerPin !== "undefined") {
        pin = box.customerPin;
      }
      if (pin === null) {
        return;
      }
      dispatch(
        paketinActions.deletePin({
          token: Biscuit.get("token"),
          boxId: box.boxId,
          pin: pin,
        }),
      );
      setDeletePinPending(true);
    }
  };

  return (
    <>
      {initialized && (
        <>
          <Dialog
            onClose={handleCloseDialog}
            aria-labelledby="changelogs-dialog-title"
            open={true}
            name="changeLogsDialog"
            id="multipleRecipientsDialog"
            maxWidth={"md"}
          >
            <header className="inb-multiple-recipients-header">
              <button
                onClick={handleCloseDialog}
                type="button"
                id="inb-multiple-recipients-dialog-close-button"
                className="button hollow secondary right button-close-multiple-recipients-dialog round"
                title={t("close show status")}
              >
                <i className="fi fi-x"></i>
              </button>
              <h4>
                {t("status", null, "capital")} {facilitySlot.resource.name}
              </h4>
              {!boxPending &&
                typeof _checkBox.data !== "undefined" &&
                _checkBox?.data?.length > 0 && (
                  <div id="inb-c-main-header">
                    <ul className="inb-tabs row">
                      <li className="tabs-title column medium-2">{t("customer pin")}</li>
                      <li className="tabs-title column medium-2">{t("merchant pin")}</li>
                      <li className="tabs-title column medium-2">{t("counter")}</li>
                      <li className="tabs-title column medium-2">{t("valid_from")}</li>
                      <li className="tabs-title column medium-2">{t("valid_to")}</li>
                      <li className="tabs-title column medium-2">&nbsp;</li>
                    </ul>
                  </div>
                )}
              {/* <label className="inb-form__controlLabel legendLabel"><a href="#"
                                                                        onClick={(e) => _showPopUp(e, 'voucher for temporary user')}><i
                className="inb-ico fi fi-info"> {t('info', null, 'capital')}</i></a></label>*/}
            </header>
            <div
              id="inb-c-main-multiple-recipients"
              className="inb-c-listing off-canvas-content"
              data-off-canvas-content=""
            >
              {!boxPending &&
              typeof _checkBox.data !== "undefined" &&
              _checkBox?.data?.length > 0 ? (
                _checkBox.data.map((checkBox, index) => {
                  return (
                    <>
                      <div className="inb-c-item inb-c-item--recipient row" key={index}>
                        <div className="medium-2 small-12 column" title={t("customer pin")}>
                          <span>
                            {typeof checkBox.customerPin !== "undefined"
                              ? checkBox.customerPin
                              : ""}
                          </span>
                        </div>
                        <div className="medium-2 small-12 column" title={t("merchant pin")}>
                          <span>
                            {typeof checkBox.merchantPin !== "undefined"
                              ? checkBox.merchantPin
                              : ""}
                          </span>
                        </div>
                        <div className={"medium-2 small-12 column"} title={t("counter")}>
                          <span>
                            {typeof checkBox.counter !== "undefined" ? checkBox.counter : ""}
                          </span>
                        </div>
                        <div
                          className={
                            "medium-" +
                            (Biscuit.get("user.is_superuser") === "true" ? "2" : "3") +
                            " small-12 column"
                          }
                          title={t("valid_from")}
                        >
                          {typeof checkBox.validFrom !== "undefined" &&
                          checkBox.validFrom !== null ? (
                            <span>{moment(checkBox.validFrom.date).format("DD.MM.YY HH:mm")}</span>
                          ) : (
                            <span>{moment(checkBox.created.date).format("DD.MM.YY HH:mm")}</span>
                          )}
                        </div>
                        <div
                          className={
                            "medium-" +
                            (Biscuit.get("user.is_superuser") === "true" ? "2" : "3") +
                            " small-12 column"
                          }
                          title={t("valid_to")}
                        >
                          <span>{moment(checkBox.validUntil.date).format("DD.MM.YY HH:mm")}</span>
                        </div>
                        {Biscuit.get("user.is_superuser") === "true" && (
                          <div
                            className="medium-2 small-3 column"
                            title={t("delete", null, "capital")}
                          >
                            {deletePinPending ? (
                              <span className="roll">
                                <img
                                  className="rollingLoader colorize-black"
                                  src="assets/img/rolling_loader.svg"
                                />
                              </span>
                            ) : (
                              <a href="#" onClick={() => deletePin(checkBox)}>
                                <i className="fi fi-trash"></i>
                              </a>
                            )}
                          </div>
                        )}
                      </div>
                    </>
                  );
                })
              ) : boxPending ? (
                <>
                  {" "}
                  <Loader mediumWidth={6} smallWidth={6} subLoaders={0} />
                </>
              ) : (
                <>
                  <div id="inb-app-collection-empty" className="inb-announcement">
                    <div className="inb-image-box">
                      <img src="assets/img/no_data.svg" />
                    </div>
                    <h3>{t("app_msg_collection_empty")}</h3>
                    <p>{t("app_msg_collection_empty_body")}</p>
                  </div>
                </>
              )}
            </div>
          </Dialog>
        </>
      )}
    </>
  );
};

export default ShowStatusDialog;
